//import createPdf from "./createPdf";
import { format, isAfter, parseISO, toDate } from "date-fns";
import logo from "./pum.json";
import NumeroALetras from "./NumerosALetras";
import { buildName, buildNameWithId, Singleton } from "helper/tools";
import createPdf from "./createPdfEstadoCuentaAsociado";

import pdfMake from "pdfmake/build/pdfmake";

function resizeArray(arr, size, filler = null) {
  // 1. Slice: Get a copy up to the desired size
  let newArr = arr.slice(0, size);

  // 2. Pad: Calculate needed elements and fill
  if (newArr.length < size) {
    const padCount = size - newArr.length;
    // Add padded items using fill
    newArr = newArr.concat(Array(padCount).fill(filler));
  }

  return newArr;
}

const generateGO = async (output, item) => {
  const response1 = await fetch("./pum.json");
  const json = await response1.json().catch((we) => {
    console.log(we);
  });

  const asociado = item.asociado;
  const nombreAsociado = buildNameWithId(asociado, null);
  const numAsociado = asociado.numAsociado;
  const asociadoCreditoAut = "???";
  const asociadoCreditoUtilizado = "???";
  const asociadoCreditoDisp = "???";
  const asociadoFechaCorte = "---";
  const asociadoFechaLimiteCorte = "---";
  const asociadoNuevosCobros = "?";
  const asociadoProductosLiquidan = "0";

  let parcialidadesProducto = [];
  item.clientes.forEach((info) => {
    const cliente = info.cliente;
    const clienteNombre = cliente ? buildName(cliente, true) : "-";

    const results = [];

    const ordenParcialidades = info.ordenParcialidades;
    ordenParcialidades.forEach((ordenParcial) => {
      //const fechaVenta = ordenParcial.ordenVenta?.fechaSurtido ?? "";
      ordenParcial.productoParcialidades.forEach((productoParcial) => {
        const nombreProducto =
          productoParcial.ordenVentaDetalle.producto.nombre;
        const fechaVenta = productoParcial.fechaInicio;
        const productoParcialTotal = productoParcial.total;

        //
        //
        const totalParcialidades = ordenParcial.totalParcialidades;

        const row = [
          clienteNombre,
          nombreProducto,
          fechaVenta,
          productoParcialTotal,
          totalParcialidades,
        ];
        //
        const allParciales = [];
        productoParcial.parcialidades.forEach((parcialidad, index) => {
          const fechaInicio = parcialidad.fechaInicio;
          const fechaFin = parcialidad.fechaFin;
          const total = parcialidad.total;

          allParciales.push(total);

          console.log(`PArcialidad # ${index} Total: $ ${total}`);
        });

        const flat = resizeArray(allParciales, 15, "-");

        row.push(...flat);

        results.push(row);
        //
      });
    });

    const autoNiveles = results.map((item) => {
      return item.map((info) => {
        //  return { text: info };
        return info;
      });
    });

    parcialidadesProducto.push(autoNiveles);
  });

  parcialidadesProducto = parcialidadesProducto.flat();

  //  parcialidadesProducto = parcialidadesProducto.slice(0, 1);

  ///
  /*  [
              {
                text: "nothing interesting here",
                italics: true,
                color: "gray",
              },
              {
                text: "nothing interesting here",
                italics: true,
                color: "gray",
              },
              {
                text: "nothing interesting here",
                italics: true,
                color: "gray",
              },
              {
                text: "nothing interesting here",
                italics: true,
                color: "gray",
              },
              {
                text: "nothing interesting here",
                italics: true,
                color: "gray",
              },
              {
                text: "nothing interesting here",
                italics: true,
                color: "gray",
              },
              {
                text: "nothing interesting here",
                italics: true,
                color: "gray",
              },
              {
                text: "nothing interesting here",
                italics: true,
                color: "gray",
              },
            ],
*/
  ///

  var docDefinition = {
    pageSize: "LETTER",
    pageOrientation: "landscape",
    content: [
      {
        alignment: "justify",
        columns: [
          {
            style: "tableExample",
            table: {
              widths: ["auto", 200],

              body: [
                [
                  { text: "Nombre de Asociado", style: "headerResumen" },
                  {
                    text: nombreAsociado,
                    alignment: "right",
                  },
                ],
                [
                  { text: "Clave Asociado", style: "headerResumen" },
                  {
                    text: numAsociado,
                    alignment: "right",
                  },
                ],
                [
                  { text: "Crédito autorizado", style: "headerResumen" },
                  {
                    text: asociadoCreditoAut,
                    alignment: "right",
                  },
                ],
                [
                  { text: "Saldo utilizado", style: "headerResumen" },
                  {
                    text: asociadoCreditoUtilizado,
                    alignment: "right",
                  },
                ],
                [
                  { text: "Saldo disponible", style: "headerResumen" },
                  {
                    text: asociadoCreditoDisp,
                    alignment: "right",
                  },
                ],
                [
                  { text: "Monto por liberar", style: "headerResumen" },
                  {
                    text: asociadoFechaCorte,
                    alignment: "right",
                  },
                ],
                [
                  { text: "Fecha de corte", style: "headerResumen" },
                  {
                    text: asociadoFechaLimiteCorte,
                    alignment: "right",
                  },
                ],
                [
                  { text: "Fecha límite de corte", style: "headerResumen" },
                  {
                    text: asociadoFechaLimiteCorte,
                    alignment: "right",
                  },
                ],
                [
                  { text: "Nuevos cobros", style: "headerResumen" },
                  {
                    text: asociadoNuevosCobros,
                    alignment: "right",
                  },
                ],
                [
                  { text: "Productos que se liquidan", style: "headerResumen" },
                  {
                    text: asociadoProductosLiquidan,
                    alignment: "right",
                  },
                ],
              ],
            },
          },
          {
            image: json.imageData,
            fit: [282, 112],
            alignment: "center",
          },
        ],
      },
      "",
      {
        alignment: "justify",
        columns: [
          {
            style: "tableExample",
            table: {
              widths: ["auto", 200],
              body: [
                [
                  { text: "Por pagar", style: "headerResumen" },
                  { text: "$0", style: "headerResumen" },
                ],
                [
                  { text: "Comisiones", style: "headerResumen" },
                  { text: "$0", style: "headerResumen" },
                ],
                [
                  { text: "Total a pagar", style: "headerPagarPuntual" },
                  { text: "$0", style: "headerPagarPuntual" },
                ],
                ["", ""],

                [
                  {
                    text: "Datos de depósito",
                    colSpan: 2,
                    alignment: "center",
                    style: "headerResumen",
                  },
                  "",
                ],
                [
                  {
                    text: "Banco / Tipo de cuenta",
                    style: "headerPagarPuntual",
                  },
                  {
                    text: "CORPORATIVO DE NEGOCIOS ANURLEY",
                    style: "headerPagarPuntual",
                  },
                ],
                [
                  { text: "Titular", style: "headerPagarPuntual" },
                  { text: "012744001234319085", style: "headerPagarPuntual" },
                ],
                [
                  { text: "Cuenta CLABE", style: "headerPagarPuntual" },
                  {
                    text: "BBVA Bancomer / Empresarial",
                    style: "headerPagarPuntual",
                  },
                ],
                [
                  { text: "REFERENCIA", style: "headerPagarPuntual" },
                  { text: "360031", style: "headerPagarPuntual" },
                ],
              ],
            },
          },

          {
            style: "tableExample",
            table: {
              body: [
                [
                  {
                    text: "Pagar puntualmente evita cargo del 10% de interes",
                    colSpan: 4,
                    alignment: "center",
                    style: "headerPagarPuntual",
                  },
                  "",
                  "",
                  "",
                ],
                [
                  {
                    text: "Fecha de pago",
                    alignment: "center",
                    style: "headerPagarPuntual",
                  },
                  {
                    text: "Interés",
                    alignment: "center",
                    style: "headerPagarPuntual",
                  },
                  {
                    text: "A pagar",
                    alignment: "center",
                    style: "headerPagarPuntual",
                  },
                  {
                    text: "Realizó pago",
                    alignment: "center",
                    style: "headerPagarPuntual",
                  },
                ],
                [
                  {
                    text: "31/1/2026",
                    alignment: "center",
                  },
                  {
                    text: "0%",
                    alignment: "center",
                  },
                  {
                    text: "$0",
                    alignment: "center",
                  },
                  "",
                ],
              ],
            },
          },
        ],
      },

      {
        style: "tableExample",
        table: {
          widths: [
            80, 80, 30, 30, 30,

            30, 30, 30, 30, 30,

            30, 30, 30, 30, 30,

            30, 30, 30, 30, 30,
          ],
          body: [
            [
              { text: "Nombre de Cliente", style: "headerResumen" },
              { text: "Producto", style: "headerResumen" },
              { text: "Fecha de Venta", style: "headerResumen" },
              { text: "Precio", style: "headerResumen" },
              { text: "Plazo", style: "headerResumen" },

              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },

              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },

              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },
              { text: "15/4/2026", style: "headerResumen" },
            ],

            [
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
              " ",
            ],

            ...parcialidadesProducto,
          ],
        },
      },
    ],
    styles: {
      headerResumen: {
        fontSize: 10,
        bold: false,
      },
      headerResumenValue: {
        fontSize: 10,
        bold: false,
      },
      headerPagarPuntual: {
        fontSize: 10,
        bold: true,
      },
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
      },
      subheader: {
        fontSize: 16,
        bold: true,
        margin: [0, 10, 0, 5],
      },
      tableExample: {
        margin: [0, 5, 0, 15],
      },
      tableHeader: {
        bold: true,
        fontSize: 13,
        color: "black",
      },
    },
    defaultStyle: {
      // alignment: 'justify'
    },
  };

  var now = new Date();

  var pdf = pdfMake.createPdf(docDefinition);
  pdf.download("my_document.pdf");
};

const generateEstadoCuentaAsociado = async (output, item) => {
  /*
  image:
  "data:image/png;base64,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AAASUVORK5CYII=", //Logo
  */

  const fechaOrden = parseISO("2025-09-11T10:30:00");

  const fechaOrdenDia = format(fechaOrden, "yyyy-MM-dd");
  const fechaOrdenHora = format(fechaOrden, "HH:mm:ss");

  /*fetch("./pum.json").then((response) =>
    response
      .json()
      .then((data) => {
        /*({
        data: data,
        status: response.status
    })
        console.log(data);
      })
      .then((res) => {
        console.log(" ... " + res);
        //console.log(res.status, res.data.title)
      })
  );*/

  const response1 = await fetch("./pum.json");
  const json = await response1.json().catch((we) => {
    console.log(we);
  });
  //  const json = JSON.stringify(re);

  const detalles = item.ordenVentaDetalles
    .map(function (info) {
      const nombre = [
        {
          text: info.producto.nombre,
          style: "tProductsBody",
          colSpan: 4,
          lineHeight: 0,
        },
        {},
        {},
        {},
      ];

      const descripcion = [
        { text: info.cantidad, style: "tProductsBody", alignment: "center" },
        {
          text: "",
          style: "tProductsBody",
          alignment: "center",
        },
        {
          text: Singleton.getInstance().format(info.precio),
          style: "tProductsBody",
          alignment: "right",
        },
        {
          text: Singleton.getInstance().format(info.total),
          style: "tProductsBody",
          alignment: "right",
        },
      ];

      const re = [nombre, descripcion];

      return re;
    })
    .flatMap((info) => info);

  const total = Singleton.getInstance().format(item.totalVenta);
  const subTotal = Singleton.getInstance().format(item.subTotalVenta);
  const descuento = Singleton.getInstance().format("0.0");
  //const subTotalLetra = NumeroALetras(item.subtotal)
  const totalLetra = NumeroALetras(item.totalVenta, true);
  //"SON: SEISCIENTOS TREINTA MIL QUINIENTOS CINCO Y CINCO CON 00/100 PESOS",

  const asociadoNombre = buildName(item.asociado, true);
  const clienteNombre = buildName(item.cliente, true);
  let domicilioCliente = "---";
  /*  if (false && item.cliente.direcciones.length > 0) {
    const address = item.cliente.direcciones[0];
    const infos = [
      address.calle,
      address.noExterior,
      address.colonia,
      address.cp,
      address.ciudad,
      address.estado,
    ];
    domicilioCliente = infos.join(", ");
  }*/

  const content = [
    //DATOS EMPRESA
    {
      image: json.imageData,
      fit: [141.73, 56.692],
      alignment: "center",
    },
    [
      {
        text: "CORPORATIVO DE NEGOCIOS ANURLEY",
        style: "link",
        colSpan: 4,
        margin: [0, 6, 0, 0],
      },
    ],

    {
      stack: [
        // second column consists of paragraphs

        `Paloma #403, Infonavit Alarcón`,
        `Mazatlán, Sinaloa`,
      ],
      style: "header",
      bold: false,
    },
    {
      text: `FOLIO: ${item.id}`,
      fontSize: 9,
      bold: true,
      alignment: "left",
      margin: [0, 0],
    },

    //DATOS CEBECERA FACTURAR
    {
      margin: [0, 10, 0, 0],
      table: {
        widths: ["25%", "35%", "15%", "25%"],
        body: [
          [
            {
              text: "FECHA:",
              style: "tHeaderLabel",
              alignment: "LEFT",
              lineHeight: 0.5,
            },
            {
              text: fechaOrdenDia,
              style: "tHeaderValue",
              alignment: "LEFT",
              lineHeight: 0.5,
            },
            {
              text: "HORA:",
              style: "tHeaderLabel",
              alignment: "LEFT",
              lineHeight: 0.5,
            },
            {
              text: fechaOrdenHora,
              style: "tHeaderValue",
              alignment: "LEFT",
              lineHeight: 0.5,
            },
          ],
          [
            {
              text: "ASOCIADO:",
              style: "tHeaderLabel",
              alignment: "LEFT",
              lineHeight: 0.5,
            },
            {
              text: asociadoNombre,
              style: "tHeaderValue",
              colSpan: 3,
              alignment: "LEFT",
              lineHeight: 0.5,
            },
            {},
            {},
          ],
        ],
      },
      layout: "noBorders",
    },
    //TABLA PRODUCTOS
    {
      margin: [0, 0, 0, 0],
      table: {
        widths: ["20%", "25%", "30%", "25%"],
        headerRows: 2,
        body: [
          [
            { text: "DESCRIPCIÓN", colSpan: 4, style: "tProductsHeader" },
            {},
            {},
            {},
          ],

          ...detalles,
        ],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 1 ? 0.5 : 0;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
        hLineColor: function () {
          return "#f2f0f0";
        },
        paddingTop: function (i, node) {
          return i % 2 === 0 ? 10 : 1;
        },
      },
    },
    {
      margin: [0, 10, 0, 0],
      table: {
        widths: ["25%", "35%", "15%", "25%"],
        body: [
          //TOTALES
          [
            { text: "SUBTOTAL: ", style: "tTotals", colSpan: 2 },
            {},
            { text: subTotal, style: "tTotals", colSpan: 2 },
            {},
          ],
          [
            { text: "BONIFICACIÓN: ", style: "tTotals", colSpan: 2 },
            {},
            { text: descuento, style: "tTotals", colSpan: 2 },
            {},
          ],
          [
            { text: "TOTAL: ", style: "tTotals", colSpan: 2 },
            {},
            { text: total, style: "tTotals", colSpan: 2 },
            {},
          ],
          //TOTAL IMPORTE EN LETRAS
          [
            {
              text: totalLetra,
              style: "tProductsBody",
              colSpan: 4,
            },
            {},
            {},
            {},
          ],
          //DATOS CLIENTE
          [
            {
              text: "CLIENTE: ",
              style: "tTotals",
              alignment: "left",
              colSpan: 4,
              margin: [0, 6, 0, 0],
            },
            {},
            {},
            {},
          ],
          [
            {
              text: clienteNombre,
              style: "tClientValue",
              alignment: "LEFT",
              colSpan: 3,
            },
            {},
            {},
            {},
          ],
          [
            { text: "DIRECCIÓN: ", style: "tClientLabel", alignment: "LEFT" },
            {},
            {},
            {},
          ],
          [
            {
              text: domicilioCliente,
              style: "tClientValue",
              colSpan: 4,
            },
          ],
          //DATOS NEGOCIO
          [
            {
              text: "Consulta terminos y condiciones en ",
              style: "link",
              colSpan: 4,
              margin: [0, 0, 0, 0],
            },
          ],
          [
            {
              text: "https://pagoni.mx/policies/terms-of-service",
              style: "link",
              colSpan: 4,
              margin: [0, 0, 0, 0],
              decoration: "underline",
            },
          ],
        ],
      },
      layout: "noBorders",
    },
  ];

  const contentA = [
    { text: "Text on Portrait" },
    {
      text: "Text on Landscape",
      pageOrientation: "landscape",
      pageBreak: "before",
    },
    {
      text: "Text on Landscape 2",
      pageOrientation: "portrait",
      pageBreak: "after",
    },
    { text: "Text on Portrait 2" },
  ];

  const response = await createPdf({ contentA }, output);
  return response;
};

export default generateGO;
